import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { LineItem } from '../types/quotation';
import { formatEuro, lineTotal } from '../utils/pricing';
const CADENCE_LABEL: Record<LineItem['cadence'], string> = {
  'one-off': 'One-off',
  'per-campaign': 'Per campaign',
  annual: 'Annual',
  monthly: 'Monthly'
};
interface LineItemRowProps {
  item: LineItem;
}
export function LineItemRow({
  item
}: LineItemRowProps) {
  const [open, setOpen] = useState(false);
  return <div className="border-b border-line last:border-b-0" data-id="element-86" data-mp="2pph09nnhe1w3">
      <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls={`line-${item.id}`} className="flex w-full flex-col gap-4 p-6 text-left transition-colors hover:bg-surface focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary sm:flex-row sm:items-center sm:gap-6" data-id="element-87" data-mp="2buww2co2fiyl">
        <ChevronDownIcon aria-hidden="true" className={`h-4 w-4 shrink-0 text-ink-300 transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-88" data-mp="1j5fpv0t6uh1z" />

        <div className="min-w-0 flex-1" data-id="element-89" data-mp="1suh3wlg6aodb">
          <div className="flex flex-wrap items-center gap-3" data-id="element-90" data-mp="1svigwvgr1kxo">
            <h4 className="font-display text-base font-semibold text-ink-900" data-id="element-91" data-mp="1o2fwbcty9ltm">
              {item.name}
            </h4>
            <span className="rounded-full bg-surface px-2.5 py-0.5 text-[11px] uppercase tracking-wider text-ink-500" data-id="element-92" data-mp="22qtv9co8wq4w">
              {CADENCE_LABEL[item.cadence]}
            </span>
          </div>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink-500" data-id="element-93" data-mp="2bsjmoii4np2o">
            {item.description}
          </p>
        </div>

        <div className="grid shrink-0 grid-cols-2 gap-6 sm:w-[300px] sm:text-right" data-id="element-94" data-mp="26s5m1liuvheo">
          <div data-id="element-95" data-mp="hh4yi64rlxp1">
            <p className="text-[11px] uppercase tracking-widest text-ink-300" data-id="element-96" data-mp="cfz3g1nmtycc">
              Unit
            </p>
            <p className="mt-1 text-sm text-ink-700" data-id="element-97" data-mp="2cigt1oy2rka6">
              {formatEuro(item.unitPrice)}
            </p>
            <p className="text-xs text-ink-300" data-id="element-98" data-mp="2hgi9s38137ih">{item.unitLabel}</p>
          </div>
          <div data-id="element-99" data-mp="2mgmpvs50y086">
            <p className="text-[11px] uppercase tracking-widest text-ink-300" data-id="element-100" data-mp="2mg4wd39qy03y">
              Total
            </p>
            <p className="mt-1 font-display text-lg font-bold tracking-tight text-ink-900" data-id="element-101" data-mp="2qiriqonnestr">
              {formatEuro(lineTotal(item))}
            </p>
            <p className="text-xs text-ink-300" data-id="element-102" data-mp="30g5x8iq0h7jf">{item.quantityLabel}</p>
          </div>
        </div>
      </button>

      <AnimatePresence initial={false} data-id="element-103" data-mp="356ckae4vkjzk">
        {open ? <motion.div id={`line-${item.id}`} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="overflow-hidden" data-id="element-104" data-mp="358z2r8tb0jwk">
            <ul className="grid gap-3 bg-surface px-6 pb-6 pt-5 sm:grid-cols-2 sm:pl-16" data-id="element-105" data-mp="3j4kp1885kpla">
              {item.includes.map(entry => <li key={entry} className="flex items-start gap-2.5 text-sm text-ink-700" data-id="element-106" data-mp="12jpgf7ylwirx">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" data-id="element-107" data-mp="yj5fdtawwv0i" />
                  {entry}
                </li>)}
            </ul>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}